import { Component } from '@angular/core';

type ChannelStyle = 'youtube' | 'youtube-shorts' | 'twitch' | 'tiktok' | 'discord';

interface CreatorChannel {
  name: string;
  handle: string;
  url: string;
  style: ChannelStyle;
  icon: string;
  label: string;
  meta: string;
}

@Component({
  selector: 'app-channels',
  standalone: true,
  template: `
    <section class="section channels-page">
      <div class="page-title-block channels-heading">
        <h1>KANÄLE</h1>
        <span class="title-line"></span>
      </div>

      <div class="channel-showcase">
        @for (channel of channels; track channel.name) {
          <a class="channel-tile" [class.youtube]="channel.style === 'youtube'" [class.youtube-shorts]="channel.style === 'youtube-shorts'" [class.twitch]="channel.style === 'twitch'" [class.tiktok]="channel.style === 'tiktok'" [class.discord]="channel.style === 'discord'" [href]="channel.url" target="_blank" rel="noreferrer">
            <span class="channel-glow"></span>
            <span class="channel-icon">{{ channel.icon }}</span>

            <div class="channel-content">
              <small>{{ channel.label }}</small>
              <h2>{{ channel.name }}</h2>
              <p>{{ channel.handle }}</p>
            </div>

            <div class="channel-bottom">
              <span>{{ channel.meta }}</span>
              <strong>Öffnen</strong>
            </div>
          </a>
        }
      </div>
    </section>
  `
})
export class ChannelsComponent {
  readonly channels: CreatorChannel[] = [
    {
      name: 'DaniiPlace',
      handle: '@DaniiPlace',
      url: 'https://youtube.com/@daniiplace',
      style: 'youtube',
      icon: '▶',
      label: 'YouTube Hauptkanal',
      meta: 'Videos & Shows'
    },
    {
      name: 'DaniiPlace Shorts',
      handle: '@DaniiPlaceShorts',
      url: 'https://youtube.com/@daniiplace',
      style: 'youtube-shorts',
      icon: '▶',
      label: 'YouTube Shorts',
      meta: 'Clips & Highlights'
    },
    {
      name: 'DaniiPlace Live',
      handle: 'twitch.tv/daniiplace',
      url: 'https://twitch.tv/daniiplace',
      style: 'twitch',
      icon: '▣',
      label: 'Twitch',
      meta: 'Streams & Community'
    },
    {
      name: 'DaniiPlace Clips',
      handle: '@daniiplace',
      url: 'https://tiktok.com/@daniiplace',
      style: 'tiktok',
      icon: '♫',
      label: 'TikTok',
      meta: 'Shortform Content'
    },
    {
      name: 'DaniiPlace Community',
      handle: 'discord.gg/daniiplace',
      url: 'https://discord.gg/daniiplace',
      style: 'discord',
      icon: '✦',
      label: 'Discord',
      meta: 'Ankündigungen & Mitspieler'
    }
  ];
}
